import React from "react";
// import backArrow from "../../../assets/icons/Back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bettingService from "../../../api/services/bettingService";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { playSong } from "../../common/actions/common.actions";
// import Share from '../../../assets/icons/share.png';
import { IoIosArrowBack } from "react-icons/io";

const SelectedMathesDetail = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedMatchesDetail } = useSelector((state) => state.sidebar);
  const { id } = useParams();
  const { t } = useTranslation();
  const [selectedMatches, setSelectedMatches] = useState([]);
  const language = localStorage.getItem("language");

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleBackClick = async () => {
    await handleSongClick();
    navigate("/selected-matches");
  };

  useEffect(() => {
    setIsLoading(true);
    bettingService
      .bettingHistoryDetails({
        gamblingId: Number(id),
        status: "Inplay",
      })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          const sortedData = data.slice().sort((a, b) => {
            const dateA = new Date(
              a.eventDate.split(" ")[0].split("-").reverse().join("-") +
                " " +
                a.eventDate.split(" ")[1]
            );
            const dateB = new Date(
              b.eventDate.split(" ")[0].split("-").reverse().join("-") +
                " " +
                b.eventDate.split(" ")[1]
            );
            return dateA - dateB;
          });
          setSelectedMatches(sortedData);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 401) {
          // Redirect to the login page
          navigate("/login");
        } else {
          console.error("API request error:", err);
        }
      });
  }, [id, navigate, setIsLoading]);

  return (
    <div className="relative flex flex-col w-full h-[100dvh] overflow-hidden bg-gradient-to-br from-silver via-gray-100 to-silver">
      {/* Professional Header */}
      <div className="relative z-10 border-b-2 shadow-2xl bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl border-crimson/40">
        <div className="flex items-center justify-between px-5 py-4">
          <button
            onClick={handleBackClick}
            className="flex items-center justify-center w-10 h-10 transition-all duration-300 text-blue-primary hover:bg-crimson/10 rounded-xl"
          >
            <IoIosArrowBack size={24} />
          </button>
          <h3 className="text-lg font-bold text-center text-blue-primary mr-7">
            {t("selectedMatches")}
          </h3>
          <div className="w-10"></div>
        </div>
        {/* Luxury Border Accent */}
        <div className="absolute bottom-0 left-0 right-0 h-1 shadow-lg bg-gradient-to-r from-crimson via-golden to-crimson"></div>
      </div>
      <div className="relative z-10 px-5 py-2 text-sm text-blue-primary text-end font-dangrek bg-white/80">
        BetID : {selectedMatchesDetail?.postingNo}
      </div>
      <div className="relative z-10 flex-1 px-1 py-4 overflow-auto">
        {selectedMatches.map((match, index) => {
          const bettedTeam =
            language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
          const oppositeTeamName =
            language === "en"
              ? match?.oppositeTeamName
              : match?.oppositeTeamNameMyan;

          return (
            <div
              key={index}
              className="flex flex-col px-3 py-3 my-1.5 border shadow-md bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl rounded-xl border-crimson/30"
            >
              {/* Date */}
              <div className="flex items-center justify-between mb-1.5 text-xs font-light sm:text-sm">
                <p className="px-2.5 py-1 font-normal text-left border rounded-md text-blue-primary bg-crimson/5 border-crimson/20">
                  {match?.eventDate}
                </p>
              </div>

              {/* Teams */}
              <div className="grid grid-cols-9 gap-[1px] mb-1">
                {/* Home */}
                <div
                  className={`${
                    match?.home === true
                      ? "bg-gradient-to-br from-crimson via-red-primary to-crimson shadow-md shadow-crimson/20 text-white border border-golden/50"
                      : "bg-white text-blue-primary border border-crimson/30"
                  } rounded-lg py-1.5 px-1 flex items-center col-span-4 transition-all duration-200`}
                >
                  <h3
                    className={`ml-auto font-normal text-center text-xs sm:text-sm flex flex-1 justify-center ${
                      match?.isHomeBodyOdd === false && "items-center"
                    }`}
                  >
                    {match.isHome ? bettedTeam : oppositeTeamName}
                  </h3>
                  {match.isHomeBodyOdd === true && (
                    <h3 className="p-1 text-xs font-bold border rounded-md bg-golden/95 text-blue-primary sm:text-sm whitespace-nowrap border-golden/60">
                      {match?.bodyOdd}
                    </h3>
                  )}
                </div>

                {/* Result */}
                <div className="flex items-center justify-center w-full text-xs text-center border rounded-md sm:text-sm text-blue-primary bg-golden/95 font-dangrek border-golden/60">
                  {`${match?.homeResult}-${match?.awayResult}`}
                </div>

                {/* Away */}
                <div
                  className={`${
                    match?.away === true
                      ? "bg-gradient-to-br from-crimson via-red-primary to-crimson shadow-md shadow-crimson/20 text-white border border-golden/50"
                      : "bg-white text-blue-primary border border-crimson/30"
                  } rounded-lg py-1.5 px-1 flex justify-center items-center col-span-4 transition-all duration-200`}
                >
                  {match?.isHomeBodyOdd === false && (
                    <h3 className="p-1 text-xs font-bold border rounded-md bg-golden/95 text-blue-primary sm:text-sm border-golden/60">
                      {match?.bodyOdd}
                    </h3>
                  )}
                  <h3
                    className={`flex flex-1 justify-center text-center font-normal text-xs sm:text-sm ${
                      match?.isHomeBodyOdd === true && "items-center"
                    }`}
                  >
                    {!match.isHome ? bettedTeam : oppositeTeamName}
                  </h3>
                </div>
              </div>

              {/* Goal Over / Under */}
              <div className="grid grid-cols-5 gap-1">
                {/* Goal Over */}
                <div
                  className={`${
                    match?.overs === true
                      ? "bg-gradient-to-br from-crimson via-red-primary to-crimson shadow-md shadow-crimson/20 text-white border border-golden/50"
                      : "bg-white text-blue-primary border border-crimson/30"
                  } rounded-lg p-1.5 col-span-2 transition-all duration-200 flex items-center justify-center`}
                >
                  <h3 className="text-xs font-normal text-center sm:text-sm">
                    {t("goalOver")}
                  </h3>
                </div>

                {/* Goal Odd */}
                <div className="flex items-center justify-center p-1 text-center border rounded-md cursor-not-allowed bg-golden/95 border-golden/60">
                  <h3 className="text-xs font-bold sm:text-sm text-blue-primary">
                    {match?.goalOdd}
                  </h3>
                </div>

                {/* Goal Under */}
                <div
                  className={`${
                    match?.under === true
                      ? "bg-gradient-to-br from-crimson via-red-primary to-crimson shadow-md shadow-crimson/20 text-white border border-golden/50"
                      : "bg-white text-blue-primary border border-crimson/30"
                  } rounded-lg p-1.5 col-span-2 flex justify-center items-center transition-all duration-200`}
                >
                  <h3 className="text-xs font-normal text-center sm:text-sm">
                    {t("goalUnder")}
                  </h3>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="relative z-10 flex flex-col w-full px-5 py-4 border-t-2 shadow-2xl bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl border-crimson/40 text-blue-primary h-max font-dangrek">
        {/* Luxury Border Accent */}
        <div className="absolute top-0 left-0 right-0 h-1 shadow-lg bg-gradient-to-r from-crimson via-golden to-crimson"></div>

        <div className="flex justify-end pb-2">
          <p className="font-bold text-xs text-blue-primary bg-white border border-crimson/30 px-3 py-1.5 rounded-lg">
            {moment(new Date(selectedMatchesDetail?.createdDate)).format(
              "DD.MM.YYYY h:mm A"
            )}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 px-4 py-2 mb-2 border bg-white/80 rounded-xl border-crimson/20">
          <h4 className="font-semibold">{t("betAmount")}</h4>
          <p className="font-bold">
            {parseInt(selectedMatchesDetail?.amount).toLocaleString()}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 px-4 py-2 border bg-white/80 rounded-xl border-crimson/20">
          <h4 className="font-semibold">{t("teamCount")}</h4>
          <p className="font-bold">{selectedMatchesDetail?.teamCount}</p>
        </div>
      </div>
    </div>
  );
};

export default SelectedMathesDetail;
